<template>
  <v-autocomplete
    :value="value"
    :items="users"
    :loading="loading"
    :search-input.sync="search"
    chips
    clearable
    hide-details
    hide-selected
    :item-text="getItemText"
    item-value="_id"
    :label="label"
    solo
    class="ma-4"
    @input="updateValue"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Nhập email để tìm kiếm và chọn người dùng
        </v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-row class="d-flex align-center">
        <v-avatar size="40">
          <img :src="item.avatar" alt="User avatar" />
        </v-avatar>
        <span class="pl-4">{{ item.name }}</span>
        <span v-if="role === 'psychology'">
          <span class="ml-4 grey--text text--darken-4">Giá ca:</span>
          <span class="ml-1 grey--text text--darken-4 font-weight-bold">
            {{ item.bookingPrice }} đ
          </span>
        </span>
      </v-row>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="indigo"
        class="headline font-weight-light white--text"
      >
        <v-avatar size="40">
          <img :src="item.avatar" alt="User avatar" />
        </v-avatar>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.name"></v-list-item-title>
        <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import UserApi from "@/api/UserApi";
export default {
  data() {
    return {
      select: null,
      users: [],
      loading: false,
      search: null
    };
  },
  props: ["value", "label", "role"],
  watch: {
    search(val) {
      this.lading = true;
      UserApi.getUsers(val, this.role, 1, 20)
        .then(response => {
          const { ok, data } = response;
          if (ok) {
            this.users = data;
          }
        })
        .catch(err => {
          alert(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    getItemText(item) {
      return `${item.name} ${item.email}`;
    },
    updateValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>
